import { render, staticRenderFns } from "./breakIcon.vue?vue&type=template&id=63389ae5"
import script from "./breakIcon.vue?vue&type=script&lang=js"
export * from "./breakIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports